import SectionTitle from '../typography/SectionTitle';

type FieldCardProps = {
  title: React.ReactNode;
  children: React.ReactNode;
};

export function FieldCard({ title, children }: FieldCardProps) {
  return (
    <div className="flex h-full flex-col rounded-lg border border-slate-200 bg-white shadow-sm transition-all hover:border-primary hover:shadow-md">
      <div className="border-b border-slate-100 px-4 py-3">
        <SectionTitle>{title}</SectionTitle>
      </div>

      <div className="flex-1 p-4">{children}</div>
    </div>
  );
}
